import PersonOutlineIcon from '@mui/icons-material/PersonOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import ProfilePage from './pages/ProfilePage';

/** Migration guide Bölüm 5.3 — always visible, no feature-flag/role gate. */
export const profileModule: ModuleDefinition = {
  routes: [{ path: 'profile', element: <ProfilePage /> }],
  menuItems: [{ label: 'Profil', path: 'profile', icon: <PersonOutlineIcon /> }],
};
